import React, { useState } from "react";
import loadScriptOnce from "load-script-once";
import { PLATFORM_CODE } from "../../page/oauth/types";
import { lib } from "react-single-app";

/**
 *
 * @param {string} rootPath
 * @param {string=} loginIdentity
 * @param {PLATFORM_CODE=} platformCode - 第三方环境平台
 * @return {{isLoadingScript, toOauth:toOauth,initOauthLogin,getRedirectUri}} - 第三方环境平台
 * @constructor
 */
export default function useOauth({ rootPath, loginIdentity, platformCode }) {
    const loginRedirectUri = lib.getParam("redirectUrl");
    const [isLoadingScript, setIsLoadingScript] = useState(false);
    /**
     * @function
     * @param {string}loginIdentity
     * @param {string}platformCode
     * @param {string=} rootPathOfFun
     */
    const toOauth = (loginIdentity, platformCode, rootPathOfFun) => {
        const CORPID = "ww17112ac89f0d7c08";
        const AGENTID = "1000026";
        const STATE = Math.random();
        const REDIRECT_URI = `${encodeURIComponent(
            getRedirectUri(rootPathOfFun ?? rootPath, loginIdentity, platformCode),
        )}`;
        window.location = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${CORPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_base&state=${STATE}&agentid=${AGENTID}#wechat_redirect`;
    };
    const getRedirectUri = (rootPath, loginIdentity, platformCode) => {
        const { origin } = window.location;
        const redirectUrl = loginRedirectUri
            ? `&redirectUrl=${encodeURIComponent(loginRedirectUri)}`
            : "";
        const platformPath = platformCode === PLATFORM_CODE.QyWx ? "qy-wx-Login" : "wxLogin";
        return `${origin}${rootPath}/${platformPath}?loginIdentity=${loginIdentity}${redirectUrl}`;
    };

    const initQRCodeLoginPanel = () => {
        setIsLoadingScript(false);
        if (platformCode === PLATFORM_CODE.QyWx) {
            window.ww &&
                window.ww.createWWLoginPanel({
                    el: "#login_container",
                    params: {
                        login_type: "CorpApp",
                        appid: "ww17112ac89f0d7c08",
                        agentid: "1000026",
                        redirect_uri: getRedirectUri(rootPath, loginIdentity, platformCode),
                        state: Math.random(),
                        redirect_type: "top",
                    },
                });
        } else if (platformCode === PLATFORM_CODE.Wx) {
            window.WxLogin &&
                new window.WxLogin({
                    self_redirect: false,
                    id: "login_container",
                    appid: "wxd68d123c6dd6bbb5",
                    response_type: "code",
                    scope: "snsapi_login",
                    redirect_uri: decodeURIComponent(
                        getRedirectUri(rootPath, loginIdentity, platformCode),
                    ), // 扫码成功后重定向地址
                    state: Math.random(),
                    style: "black",
                    href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIzMHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuanNfd3hfZGVmYXVsdF90aXAge2Rpc3BsYXk6IG5vbmU7fQ0KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyNjVweDt9DQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fSA=",
                });
        }
    };
    const initOauthLogin = () => {
        let scriptUrl = "";
        if (platformCode === PLATFORM_CODE.Wx) {
            scriptUrl = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
        } else if (platformCode === PLATFORM_CODE.QyWx) {
            scriptUrl = "https://wwcdn.weixin.qq.com/node/open/js/wecom-jssdk-1.3.1.js";
        }
        loadScriptOnceSync(scriptUrl, () => {
            setIsLoadingScript(true);
            const timer = setTimeout(() => {
                initQRCodeLoginPanel();
                clearTimeout(timer);
            }, 500);
        });
    };
    function loadScriptOnceSync(src, success) {
        loadScriptOnce(src).then(() => {
            if (typeof success === "function") {
                success();
            }
        });
    }
    return { isLoadingScript, toOauth, initOauthLogin, getRedirectUri };
}
